import type { ValueAvailability } from "~/components/product/variant/availability";

export type SizeStockKind = "in" | "low" | "unavailable";

export interface SizeStock {
  kind: SizeStockKind;
  /** Short human label; empty for the healthy "in stock" case. */
  label: string;
}

/**
 * Map a size value's engine availability to a display state (P3-06):
 * - `unavailable` — no purchasable variant for the current colour (disabled + struck).
 * - `low` — purchasable with stock at/below the threshold ("Only N left").
 * - `in` — purchasable with healthy stock (no label).
 *
 * Pure; the "Only N" surfaces the *candidate* variant's stock (aggregate across
 * matching variants), so a backorder/preorder size with 0 stock reads as `in`,
 * not low — it's purchasable without being scarce.
 */
export function sizeStock(
  availability: ValueAvailability | undefined,
  lowStockThreshold: number,
): SizeStock {
  if (!availability?.available)
    return { kind: "unavailable", label: "Unavailable" };
  const { stock } = availability;
  if (stock > 0 && stock <= lowStockThreshold) {
    return { kind: "low", label: `Only ${stock} left` };
  }
  return { kind: "in", label: "" };
}
